import '!file-loader?name=[name].[ext]!../../images/empty-logo.png';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { push as MobileBurgerMenu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { isMenuActive } from './shared';
import SwitchOrganisation from './switchOrganisation';

export const AccountWrapper = styled.div`
  float: right;
  font-size: 16px;
  font-family: MuseoSansRounded700;
  font-weight: normal;
  outline: none !important;

  @media ${(props) => props.theme.device.mobile} {
    width: 100%;
    height: 99px;
    border-bottom: 1px solid rgba(233, 233, 233, 0.3);
    padding: 24px;
  }
`;

export const Account = styled.a`
  display: inline-block;
  border-radius: 24px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 15px 0;
  padding-right: 24px;
  height: 50px;
  line-height: 50px;
  color: #ffffff;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: nowrap;
  max-width: 240px;

  @media ${(props) => props.theme.device.mobile} {
    width: 100%;
    height: 51px;
    margin: 0;
  }
`;

export const Avatar = styled.img`
  float: left;
  width: 38px;
  height: 38px;
  margin: 6px 15px 6px 6px;
  border: 4px solid #fff;
  border-radius: 19px;
  background-color: #fff;

  @media ${(props) => props.theme.device.tablet} {
    float: none;
    margin: 0px;
  }
`;

const MobileMenuItem = styled(Link)`
  height: 64px;
  width: 100%;
  line-height: 64px;
  display: inline-block;
  color: ${(props) => (props.active ? '#ffffff' : 'rgba(255, 255, 255, 0.6)')};
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  padding-left: 8px;
`;

const ItemIconWrapper = styled.div`
  float: left;
  width: 64px;
  height: auto;
  line-height: 64px;
  text-align: center;
`;

const MobileMenuItemBottomLine = styled.div`
  height: 64px;
  width: 100%;
  line-height: 64px;
  display: inline-block;
  color: ${(props) => (props.active ? '#ffffff' : 'rgba(255, 255, 255, 0.6)')};
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  padding-left: 8px;
  border-bottom: 1px solid rgba(233, 233, 233, 0.3);
`;

const mobileMenuStyles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '36px',
    top: '36px',
  },
  bmBurgerBars: {
    background: '#373a47',
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    display: 'none',
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },
  bmMenu: {
    background: '#34346d',
    // padding: '2.5em 1.5em 0',
    fontSize: '1.15em',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
    // padding: '0.8em'
  },
  bmItem: {
    display: 'inline-block',
    // padding: '32px',
    // lineHeight: '32px'
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0)',
  },
};

const emptyLogo = '/empty-logo.png';

function MobileMenu(props) {
  const {
    user,
    isContactOrAdmin,
    isMobileMenuOpen,
    toggleMobileMenu,
    handleMobileMenuStateChange,
    clearLinkedOrganisations,
    resetUserUpdate,
  } = props;

  const [showSwitchOrganisation, setShowSwitchOrganisation] = useState(false);

  useEffect(() => {
    if (!showSwitchOrganisation) {
      clearLinkedOrganisations();
    }
  }, [showSwitchOrganisation]);

  const toggleShowSwitchOrganisation = () =>
    setShowSwitchOrganisation(!showSwitchOrganisation);

  const toggleMenuAndSwitch = () => {
    toggleMobileMenu();
    toggleShowSwitchOrganisation();
  };

  const goToProfilePage = () => {
    resetUserUpdate();
    toggleMobileMenu();
  };

  const hasAtLeastOneOrganisation = !!user?.organisationName;

  return (
    <>
      <MobileBurgerMenu
        pageWrapId="dashboard"
        outerContainerId="outer-container"
        styles={mobileMenuStyles}
        customBurgerIcon={false}
        customCrossIcon={false}
        isOpen={isMobileMenuOpen}
        onStateChange={handleMobileMenuStateChange}
        width="86%"
      >
        <AccountWrapper>
          {hasAtLeastOneOrganisation && (
            <Account id="accountInfo">
              <Avatar src={user.logo || emptyLogo} />
              {user.internalPortalName}{' '}
              {false && <i className="fa fa-caret-down" />}
            </Account>
          )}
        </AccountWrapper>
        {user.canSwitch && hasAtLeastOneOrganisation && (
          <MobileMenuItemBottomLine
            id="switchOrganisation"
            onClick={toggleMenuAndSwitch}
          >
            <FormattedMessage {...messages.switch} />
            <ItemIconWrapper>
              <svg
                width="28"
                height="23"
                viewBox="0 0 28 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Switch icon"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.9286 7.20123L14.9286 16.8891C14.9286 20.1068 12.4833 22.7251 9.47816 22.7251H9.36915C6.36398 22.7251 3.91868 20.1068 3.91868 16.8891L3.91868 6.85107L3.9745 5.48871L2.30796 7.2722C1.79692 7.81939 0.969325 7.81939 0.458289 7.2722C-0.0527469 6.72501 -0.0527469 5.83887 0.458289 5.29168L4.34077 1.13549C4.8518 0.588301 5.68028 0.588301 6.19044 1.13549L10.0729 5.29168C10.3284 5.56528 10.4558 5.92384 10.4558 6.28241C10.4558 6.64004 10.3284 6.99861 10.0729 7.2722C9.56188 7.81939 8.73341 7.81939 8.22238 7.2722L6.47735 5.4028L6.53491 6.81185L6.53491 16.8891C6.53491 18.5624 7.8064 19.9238 9.36915 19.9238H9.47816C11.0409 19.9238 12.3124 18.5624 12.3124 16.8891L12.3124 7.20123C12.3124 3.98347 14.7577 1.36519 17.7629 1.36519C20.7681 1.36519 23.2134 3.98347 23.2134 7.20123V16.0328L23.1227 18.0339L24.9566 16.0692C25.4677 15.522 26.2953 15.522 26.8063 16.0692C27.0618 16.3428 27.19 16.7014 27.19 17.0599C27.19 17.4176 27.0618 17.7761 26.8063 18.0497L22.9247 22.2059C22.4137 22.7531 21.5861 22.7531 21.075 22.2059L17.1925 18.0497C16.6815 17.5025 16.6815 16.6164 17.1925 16.0692C17.7036 15.522 18.5312 15.522 19.0422 16.0692L20.6817 17.8247L20.5971 15.9161V7.20123C20.5971 5.52792 19.3256 4.16649 17.7629 4.16649C16.2001 4.16649 14.9286 5.52792 14.9286 7.20123Z"
                  fill="#717199"
                />
              </svg>
            </ItemIconWrapper>
          </MobileMenuItemBottomLine>
        )}
        {!user.cashbackEnabled && hasAtLeastOneOrganisation && (
          <>
            <MobileMenuItem
              id="transactionPage"
              to="/transactions"
              onClick={toggleMobileMenu}
              active={isMenuActive(['/transactions'])}
            >
              <FormattedMessage {...messages.transactions} />
              <ItemIconWrapper>
                <svg
                  width="32px"
                  height="24px"
                  viewBox="0 0 17 13"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="//-Style" stroke="none">
                    <g
                      id="Icons"
                      transform="translate(-371.000000, -170.000000)"
                    >
                      <path
                        d="M371,175.017644 L387.111111,175.017644 L387.111111,181.04638 C387.111111,182.061874 386.337724,182.888889 385.38808,182.888889 L372.723031,182.888889 C371.773387,182.888889 371,182.061874 371,181.04638 L371,175.017644 Z M387.111111,172.891719 L371,172.891719 L371,171.842509 C371,170.827015 371.773387,170 372.723031,170 L385.38808,170 C386.337724,170 387.111111,170.827015 387.111111,171.842509 L387.111111,172.891719 Z"
                        id="bank-card-filled"
                      />
                    </g>
                  </g>
                </svg>
              </ItemIconWrapper>
            </MobileMenuItem>
            <MobileMenuItem
              id="tikkiePage"
              to="/"
              onClick={toggleMobileMenu}
              active={isMenuActive(['/', '/bulk'])}
            >
              <FormattedMessage {...messages.paymentRequests} />
              <ItemIconWrapper>
                <svg
                  width="32px"
                  height="31px"
                  viewBox="0 0 19 18"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="//-Style" stroke="none" fill="">
                    <g
                      id="Icons"
                      transform="translate(-431.000000, -168.000000)"
                      fill=""
                    >
                      <path
                        d="M440.983026,168 C445.962977,168 450,172.02154 450,177.000068 C450,181.978595 445.962977,186 440.983026,186 C439.125297,186 437.399143,185.527792 435.9644,184.446297 L435.962642,184.446297 C435.947497,184.446297 435.92843,184.424667 435.906794,184.424667 C435.885293,184.424667 435.866226,184.446297 435.850946,184.446297 L435.849864,184.446297 C434.17158,185.933353 431,185.899556 431,185.899556 C431,185.899556 433.243527,184.910934 433.243527,181.858549 L433.243527,181.591015 C432.432174,180.249285 431.98025,178.685443 431.98025,177.014397 C431.98025,172.03587 436.003075,168 440.983026,168 Z M436.521189,178.300331 L436.651554,178.300331 C436.846899,179.171647 437.224674,179.935693 437.811113,180.57918 C438.683977,181.530915 439.778555,182 441.094444,182 C441.863178,182 442.540697,181.839163 443.113951,181.517489 C443.700256,181.182388 443.98695,180.793583 444,180.337924 C444,179.788282 443.648191,179.252066 443.140051,179.23864 C442.892506,179.225214 442.605812,179.332484 442.280102,179.547026 C441.954393,179.748142 441.563568,179.855274 441.107494,179.855274 C440.364859,179.855274 439.778555,179.587166 439.348581,179.064376 C439.166151,178.836547 439.022736,178.581865 438.918472,178.300331 L440.221445,178.300331 C440.534239,178.300331 440.729719,178.139494 440.729719,177.777541 C440.729719,177.469154 440.534239,177.281603 440.221445,177.281603 L438.710077,177.281603 L438.710077,177.026922 C438.710077,176.879372 438.723127,176.718535 438.736177,176.557698 L440.977129,176.557698 C441.302839,176.557698 441.498318,176.396861 441.498318,176.034908 C441.498318,175.726522 441.302839,175.53897 440.977129,175.53897 L438.983721,175.53897 C439.074936,175.324429 439.205166,175.123313 439.348581,174.935762 C439.778555,174.412972 440.364859,174.144864 441.107494,174.144864 C441.563568,174.144864 441.954393,174.251997 442.280102,174.466538 C442.605812,174.667654 442.892506,174.774786 443.140051,174.761499 C443.648191,174.748073 444,174.225283 444,173.648788 C443.98695,173.206417 443.700256,172.81775 443.113951,172.496076 C442.540697,172.160837 441.863178,172 441.094444,172 C439.778555,172 438.683977,172.469224 437.811113,173.420959 C437.263823,174.010741 436.886049,174.72122 436.690569,175.53897 L436.521189,175.53897 C436.16938,175.53897 436,175.726522 436,176.034908 C436,176.396861 436.16938,176.557698 436.521189,176.557698 L436.547289,176.557698 C436.534239,176.718535 436.534239,176.879372 436.534239,177.026922 L436.521189,177.281603 C436.16938,177.281603 436,177.469154 436,177.777541 C436,178.139494 436.16938,178.300331 436.521189,178.300331 Z"
                        id="Combined-Shape"
                      />
                    </g>
                  </g>
                </svg>
              </ItemIconWrapper>
            </MobileMenuItem>
          </>
        )}
        {!!user.cashbackEnabled && hasAtLeastOneOrganisation && (
          <>
            <MobileMenuItem
              id="cashbackPage"
              to="/tikkieterug"
              onClick={toggleMobileMenu}
              active={isMenuActive(['/tikkieterug'])}
            >
              <FormattedMessage {...messages.cashback} />
              <ItemIconWrapper>
                <svg
                  width="32px"
                  height="31px"
                  viewBox="0 0 19 18"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="//-Style" stroke="none" fill="">
                    <g
                      id="Icons"
                      transform="translate(-431.000000, -168.000000)"
                      fill=""
                    >
                      <path
                        d="M440.983026,168 C445.962977,168 450,172.02154 450,177.000068 C450,181.978595 445.962977,186 440.983026,186 C439.125297,186 437.399143,185.527792 435.9644,184.446297 L435.962642,184.446297 C435.947497,184.446297 435.92843,184.424667 435.906794,184.424667 C435.885293,184.424667 435.866226,184.446297 435.850946,184.446297 L435.849864,184.446297 C434.17158,185.933353 431,185.899556 431,185.899556 C431,185.899556 433.243527,184.910934 433.243527,181.858549 L433.243527,181.591015 C432.432174,180.249285 431.98025,178.685443 431.98025,177.014397 C431.98025,172.03587 436.003075,168 440.983026,168 Z M436.521189,178.300331 L436.651554,178.300331 C436.846899,179.171647 437.224674,179.935693 437.811113,180.57918 C438.683977,181.530915 439.778555,182 441.094444,182 C441.863178,182 442.540697,181.839163 443.113951,181.517489 C443.700256,181.182388 443.98695,180.793583 444,180.337924 C444,179.788282 443.648191,179.252066 443.140051,179.23864 C442.892506,179.225214 442.605812,179.332484 442.280102,179.547026 C441.954393,179.748142 441.563568,179.855274 441.107494,179.855274 C440.364859,179.855274 439.778555,179.587166 439.348581,179.064376 C439.166151,178.836547 439.022736,178.581865 438.918472,178.300331 L440.221445,178.300331 C440.534239,178.300331 440.729719,178.139494 440.729719,177.777541 C440.729719,177.469154 440.534239,177.281603 440.221445,177.281603 L438.710077,177.281603 L438.710077,177.026922 C438.710077,176.879372 438.723127,176.718535 438.736177,176.557698 L440.977129,176.557698 C441.302839,176.557698 441.498318,176.396861 441.498318,176.034908 C441.498318,175.726522 441.302839,175.53897 440.977129,175.53897 L438.983721,175.53897 C439.074936,175.324429 439.205166,175.123313 439.348581,174.935762 C439.778555,174.412972 440.364859,174.144864 441.107494,174.144864 C441.563568,174.144864 441.954393,174.251997 442.280102,174.466538 C442.605812,174.667654 442.892506,174.774786 443.140051,174.761499 C443.648191,174.748073 444,174.225283 444,173.648788 C443.98695,173.206417 443.700256,172.81775 443.113951,172.496076 C442.540697,172.160837 441.863178,172 441.094444,172 C439.778555,172 438.683977,172.469224 437.811113,173.420959 C437.263823,174.010741 436.886049,174.72122 436.690569,175.53897 L436.521189,175.53897 C436.16938,175.53897 436,175.726522 436,176.034908 C436,176.396861 436.16938,176.557698 436.521189,176.557698 L436.547289,176.557698 C436.534239,176.718535 436.534239,176.879372 436.534239,177.026922 L436.521189,177.281603 C436.16938,177.281603 436,177.469154 436,177.777541 C436,178.139494 436.16938,178.300331 436.521189,178.300331 Z"
                        id="Combined-Shape"
                      />
                    </g>
                  </g>
                </svg>
              </ItemIconWrapper>
            </MobileMenuItem>

            <MobileMenuItem
              id="campaignsPage"
              to="/campaigns"
              onClick={toggleMobileMenu}
              active={isMenuActive(['/campaigns'])}
            >
              <FormattedMessage {...messages.campaigns} />
              <ItemIconWrapper>
                <svg
                  width="32px"
                  height="31px"
                  viewBox="0 0 19 18"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="//-Style" stroke="none" fill="">
                    <g
                      id="Icons"
                      transform="translate(-431.000000, -168.000000)"
                      fill=""
                    >
                      <path
                        d="M440.983026,168 C445.962977,168 450,172.02154 450,177.000068 C450,181.978595 445.962977,186 440.983026,186 C439.125297,186 437.399143,185.527792 435.9644,184.446297 L435.962642,184.446297 C435.947497,184.446297 435.92843,184.424667 435.906794,184.424667 C435.885293,184.424667 435.866226,184.446297 435.850946,184.446297 L435.849864,184.446297 C434.17158,185.933353 431,185.899556 431,185.899556 C431,185.899556 433.243527,184.910934 433.243527,181.858549 L433.243527,181.591015 C432.432174,180.249285 431.98025,178.685443 431.98025,177.014397 C431.98025,172.03587 436.003075,168 440.983026,168 Z M436.521189,178.300331 L436.651554,178.300331 C436.846899,179.171647 437.224674,179.935693 437.811113,180.57918 C438.683977,181.530915 439.778555,182 441.094444,182 C441.863178,182 442.540697,181.839163 443.113951,181.517489 C443.700256,181.182388 443.98695,180.793583 444,180.337924 C444,179.788282 443.648191,179.252066 443.140051,179.23864 C442.892506,179.225214 442.605812,179.332484 442.280102,179.547026 C441.954393,179.748142 441.563568,179.855274 441.107494,179.855274 C440.364859,179.855274 439.778555,179.587166 439.348581,179.064376 C439.166151,178.836547 439.022736,178.581865 438.918472,178.300331 L440.221445,178.300331 C440.534239,178.300331 440.729719,178.139494 440.729719,177.777541 C440.729719,177.469154 440.534239,177.281603 440.221445,177.281603 L438.710077,177.281603 L438.710077,177.026922 C438.710077,176.879372 438.723127,176.718535 438.736177,176.557698 L440.977129,176.557698 C441.302839,176.557698 441.498318,176.396861 441.498318,176.034908 C441.498318,175.726522 441.302839,175.53897 440.977129,175.53897 L438.983721,175.53897 C439.074936,175.324429 439.205166,175.123313 439.348581,174.935762 C439.778555,174.412972 440.364859,174.144864 441.107494,174.144864 C441.563568,174.144864 441.954393,174.251997 442.280102,174.466538 C442.605812,174.667654 442.892506,174.774786 443.140051,174.761499 C443.648191,174.748073 444,174.225283 444,173.648788 C443.98695,173.206417 443.700256,172.81775 443.113951,172.496076 C442.540697,172.160837 441.863178,172 441.094444,172 C439.778555,172 438.683977,172.469224 437.811113,173.420959 C437.263823,174.010741 436.886049,174.72122 436.690569,175.53897 L436.521189,175.53897 C436.16938,175.53897 436,175.726522 436,176.034908 C436,176.396861 436.16938,176.557698 436.521189,176.557698 L436.547289,176.557698 C436.534239,176.718535 436.534239,176.879372 436.534239,177.026922 L436.521189,177.281603 C436.16938,177.281603 436,177.469154 436,177.777541 C436,178.139494 436.16938,178.300331 436.521189,178.300331 Z"
                        id="Combined-Shape"
                      />
                    </g>
                  </g>
                </svg>
              </ItemIconWrapper>
            </MobileMenuItem>
          </>
        )}
        <MobileMenuItem
          id="profilePage"
          to="/profile"
          onClick={goToProfilePage}
          active={isMenuActive(['/profile'])}
        >
          <FormattedMessage {...messages.profile} />
          <ItemIconWrapper>
            <svg
              width="32"
              height="31"
              viewBox="0 0 24 25"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z" />
                <circle
                  cx="12"
                  cy="9.22741"
                  r="3.36364"
                  stroke="#34346D"
                  strokeWidth="2"
                />
                <path
                  d="M19.6364 23.4093C19.6364 19.1919 16.2175 15.7729 12 15.7729C7.78256 15.7729 4.36365 19.1919 4.36365 23.4093"
                  stroke="#34346D"
                  strokeWidth="2"
                />
              </g>
            </svg>
          </ItemIconWrapper>
        </MobileMenuItem>
        {isContactOrAdmin && hasAtLeastOneOrganisation && (
          <MobileMenuItem
            id="settings"
            to="/settings"
            onClick={toggleMobileMenu}
            active={isMenuActive(['/settings'])}
          >
            <FormattedMessage {...messages.settings} />
            <ItemIconWrapper>
              <svg width="32px" height="32px" viewBox="0 0 22 22">
                <g stroke="none" strokeWidth="1" fillRule="evenodd">
                  <g
                    transform="translate(-1226.000000, -29.000000)"
                    fillRule="nonzero"
                  >
                    <path
                      d="M1245.40478,41.0779281 C1245.44987,40.7258439 1245.48391,40.373929 1245.48391,39.9999013 C1245.48391,39.6258736 1245.44984,39.2739868 1245.40478,38.9218745 L1247.79093,37.1068768 C1248.00559,36.941877 1248.06239,36.6448492 1247.92649,36.4028777 L1245.6649,32.5968262 C1245.52938,32.3548547 1245.22381,32.2668266 1244.97506,32.3548547 L1242.15918,33.4549661 C1241.57117,33.0148538 1240.93809,32.6518825 1240.24825,32.3769393 L1239.81847,29.4618584 C1239.78439,29.1979715 1239.547,29 1239.26415,29 L1234.74063,29 C1234.45797,29 1234.22058,29.1979715 1234.18651,29.4618584 L1233.75696,32.3769675 C1233.06708,32.6519107 1232.43384,33.0259102 1231.84579,33.4549943 L1229.02992,32.3548829 C1228.76979,32.2559958 1228.4758,32.3548829 1228.34004,32.5968544 L1226.07849,36.4028777 C1225.93139,36.6448492 1225.99918,36.941877 1226.21404,37.1068768 L1228.6002,38.9218745 C1228.55493,39.2739586 1228.52106,39.63693 1228.52106,39.9999013 C1228.52106,40.3628444 1228.55493,40.7258157 1228.6002,41.0779281 L1226.21404,42.8929258 C1225.99918,43.0579538 1225.94275,43.3547842 1226.07849,43.5967556 L1228.34007,47.402779 C1228.4758,47.6447505 1228.78116,47.7327503 1229.02995,47.6447505 L1231.84582,46.5450057 C1232.43384,46.9847795 1233.06711,47.3479201 1233.75699,47.6230325 L1234.18654,50.537775 C1234.22061,50.801831 1234.45803,51 1234.74066,51 L1239.26417,51 C1239.54703,51 1239.78442,50.8018592 1239.81849,50.537775 L1240.24825,47.6230325 C1240.93809,47.3479201 1241.57117,46.9740898 1242.15918,46.5450057 L1244.97506,47.6447505 C1245.23518,47.7438349 1245.52938,47.6447505 1245.6649,47.402779 L1247.92649,43.5967556 C1248.06242,43.3547842 1248.00562,43.0579256 1247.79093,42.8929258 L1245.40478,41.0779281 Z M1236.99999,44 C1234.79424,44 1233,42.2057239 1233,40.0001026 C1233,37.7942761 1234.79424,36 1236.99999,36 C1239.20573,36 1241,37.7942761 1241,40.0001026 C1241,42.2057532 1239.20573,44 1236.99999,44 Z"
                      id="XMLID_9_"
                    />
                  </g>
                </g>
              </svg>
            </ItemIconWrapper>
          </MobileMenuItem>
        )}
      </MobileBurgerMenu>
      {showSwitchOrganisation && (
        <SwitchOrganisation
          toggleShowSwitchOrganisation={toggleShowSwitchOrganisation}
          showSwitchOrganisation={showSwitchOrganisation}
          linkedOrganisations={props.linkedOrganisations}
          linkedOrganisationsIsLoading={props.linkedOrganisationsIsLoading}
          linkedOrganisationsLoadError={props.linkedOrganisationsLoadError}
          loadLinkedOrganisations={props.loadLinkedOrganisations}
          currentOrganisation={props.user.organisationId}
          switchOrganisation={props.switchOrganisation}
        />
      )}
    </>
  );
}

MobileMenu.propTypes = {
  user: PropTypes.object.isRequired,
  isContactOrAdmin: PropTypes.bool.isRequired,
  isMobileMenuOpen: PropTypes.bool.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired,
  handleMobileMenuStateChange: PropTypes.func.isRequired,
  turnOffBackgroundScroll: PropTypes.func.isRequired,
  turnOnBackgroundScroll: PropTypes.func.isRequired,
  linkedOrganisations: PropTypes.array,
  linkedOrganisationsIsLoading: PropTypes.bool,
  linkedOrganisationsLoadError: PropTypes.object,
  loadLinkedOrganisations: PropTypes.func.isRequired,
  clearLinkedOrganisations: PropTypes.func.isRequired,
  switchOrganisation: PropTypes.func.isRequired,
  resetUserUpdate: PropTypes.func.isRequired,
};

export default MobileMenu;
